import { Icon, type IconTone } from './Icon';

/** Принято. */
export function CheckIcon({ size, tone }: { size?: number; tone?: IconTone }) {
  return (
    <Icon size={size} box={12} strokeWidth={1.4} tone={tone}>
      <path d="M2.4 6.2 L5 8.8 L9.6 3.4" />
    </Icon>
  );
}
